/**
 * Org Param Group: Notas fiscais de entrada ('invoice')
 *
 * Operational settings for inbound NF-e reconciliation. Consumed via
 * `useOrgParams('invoice')` (e.g. product suggestion NCM rule in 0144 / S-ANA-74).
 */
const parameters = [
    {
        key: 'productMatchNcmRule',
        label: 'Regra de NCM na sugestão de produto',
        type: 'enum',
        scope: 'module',
        options: [
            { value: 'modulate', label: 'NCM ajuda a ordenar as sugestões' },
            { value: 'require', label: 'NCM deve ser igual ao do produto' },
        ],
        default: 'modulate',
        required: false,
        orgEditable: true,
    },
    {
        key: 'productMatchByCode',
        label: 'Casar o código do fornecedor com o código do produto',
        type: 'boolean',
        scope: 'module',
        default: true,
        required: false,
        orgEditable: true,
        description: 'Desmarcado: o código do fornecedor (cProd) igual ao código do produto deixa de escolher o produto na nota.',
    },
];
export const invoiceOrgParamGroup = {
    key: 'invoice',
    label: 'Notas fiscais de entrada',
    version: 2,
    parameters,
};
//# sourceMappingURL=invoice.orgParamGroup.js.map